export function acceptRotateDrag(event) {
  return event.button === 0;
}
